import { Component, OnInit, Input } from '@angular/core';
import { Fornitore } from '../model/fornitore';

@Component({
  selector: 'app-fornitori',
  templateUrl: './fornitori.component.html',
  styleUrls: ['./fornitori.component.scss']
})
export class FornitoriComponent implements OnInit {

  @Input () fornitore:Fornitore ;
  @Input () comodity:number ;


  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/fornitori/fornitori.component.ts